module.exports = __webpack_public_path__ + "img/internship-positions.61e152e7.png";